import { useAppSelector } from '../redux/hooks';
import { selectUserId } from '../redux/user/user';
import { getBackrsToken, isGuestToken } from '../utils/tokenHelpers';

export type UseAuthResult = Readonly<{
  loggedIn: boolean;
  isGuest: boolean;
  isUserOrGuest: boolean;
}>;

export const useAuth = (): UseAuthResult => {
  const accessToken = getBackrsToken();
  const isGuest = isGuestToken(accessToken);
  const userId = useAppSelector(selectUserId);

  return {
    loggedIn: !!accessToken && !isGuest,
    isGuest,
    isUserOrGuest: !!userId || isGuest,
  };
};
